import React, { Fragment, useEffect, useState } from "react";
import { QRCodeCanvas  } from "qrcode.react";
import { Dialog, Transition } from "@headlessui/react";
import useLoading from "../../hooks/useLoading";


export default function QrGenerator({ isOpen, onClose, data}) {

  const handleOnClose = () => {
    onClose();
  };

  return (
      <Transition.Root show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => handleOnClose()}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Dialog.Panel className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 flex flex-col gap-8 items-center">
                <div className="w-full bg-gray-100 rounded-xl px-4 py-3 text-center text-lg font-semibold text-gray-800 shadow-sm">
                  쿠폰번호 : <span className="font-mono text-indigo-600">{data.coupon_no}</span>
                </div>
                <div className="flex justify-center">
                  <div className="bg-white rounded-xl p-4 shadow-md">
                    <QRCodeCanvas value={data.qr_txt || " "} size={200} />
                  </div>
                </div>
                <button
                  type="button"
                  onClick={onClose}
                  className="w-full py-2 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white font-semibold text-lg shadow"
                >
                  닫기
                </button>
              </Dialog.Panel>
            </div>
          </div>

        </Dialog>
      </Transition.Root>
    );
}
